// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__v_E3b","header":"styles_header__kyHPK","row":"styles_row__Ed5__"};